import { connect } from 'react-redux'
import { compose } from 'recompose'

import {
  isDetachedModeEnabled,
  isSidebarCollapsed,
  isMetaPanelOpen,
} from 'data/ui/selectors'
import { collapseSidebar, uncollapseSidebar } from 'data/ui/actions'
import { isOnboardingActive } from 'screens/OnboardingPopover/utils'
import { withNoteMetaPanelControls } from 'routes/utils/withNoteMetaPanelControls'

export default compose(
  withNoteMetaPanelControls,
  connect(
    (state, { router }) => ({
      isOnboardingActive: isOnboardingActive(state),
      isDetachedMode: isDetachedModeEnabled(state),
      isSidebarCollapsed: isSidebarCollapsed(state),
      isMetaPanelOpen: isMetaPanelOpen(state),
    }),
    { collapseSidebar, uncollapseSidebar }
  )
)
